import BG from "../../BG";
import Header from "../../Header";
import Body from "../../Body";
import Title from "../../Title";
import ButtonGroups from "../../ButtonGroups";
import Button from "../../Button";
import Image from "../../Image";

import setCurrentPage from "src/Utils/setCurrentPage";

import "./index.css";

interface EndTemplateProps {
  data: DataEndTemplate;
}

const EndTemplate = ({ data }: EndTemplateProps) => {
  const {
    bgImage,
    title,
    optionsButtons,
    headerRightText,
    headerRightTextStyle,
    headerLeftImage,
    image,
  } = data;

  const templateType = "end-template";

  return (
    <BG bgImage={bgImage}>
      <Header
        onClickHome={() => setCurrentPage(1)}
        rightText={headerRightText}
        leftImage={headerLeftImage}
        rightTextStyle={headerRightTextStyle}
      />
      <Body>
        <div className="end-container">
          {image && (
            <Image imagePath={image} style={{ marginBottom: "42px" }} />
          )}
          <Title type={templateType} text={title} />
          <ButtonGroups>
            {optionsButtons.map((button, index) => (
              <Button key={index} {...button} />
            ))}
          </ButtonGroups>
        </div>
      </Body>
    </BG>
  );
};

export default EndTemplate;
